import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Clock } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { SiteFooter } from "../components/SiteFooter";
import { PageHero } from "../components/PageHero";
import { SavingsCalculator } from "../components/SavingsCalculator";
import { IMAGES, AUTO_WASH_HOURS } from "../lib/business";
import api from "../lib/api";

const PERKS = [
  "Unlimited automatic washes, every day",
  "Auto-renews monthly — cancel anytime",
  "10% off every extra car you add",
  "Instant QR check-in — no queues",
  "One membership per number plate",
  "Members only — covers the auto wash (self-serve & dog wash are pay as you go)",
];

export default function Membership() {
  const [price, setPrice] = useState(49.95);
  useEffect(() => { api.get("/config").then((r) => r.data?.price && setPrice(r.data.price)).catch(() => {}); }, []);
  const extra = (price * 0.9).toFixed(2);

  return (
    <div className="min-h-screen bg-background grain">
      <Navbar />
      <PageHero testid="membership-hero" eyebrow="Auto Wash Membership" title={<>Unlimited Washes.<br />One Flat Price.</>} image={IMAGES.autoWash}
        text="Unlimited automatic car washes for one monthly price per number plate. Show your membership, scan the QR and roll in.">
        <div className="mt-8 overline text-volt flex items-center gap-2" data-testid="auto-wash-hours"><Clock className="w-4 h-4" /> {AUTO_WASH_HOURS}</div>
      </PageHero>

      <section className="mx-auto max-w-7xl px-6 py-20 grid lg:grid-cols-2 gap-12">
        <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10 self-start">
          <div className="bg-background p-8" data-testid="membership-first-car-price">
            <div className="overline text-muted-foreground mb-3">First Car</div>
            <div className="font-head font-black text-5xl">${price}</div>
            <div className="overline text-muted-foreground mt-2">AUD / month</div>
          </div>
          <div className="bg-background p-8" data-testid="membership-extra-car-price">
            <div className="overline text-volt mb-3">Each Extra Car — 10% Off</div>
            <div className="font-head font-black text-5xl">${extra}</div>
            <div className="overline text-muted-foreground mt-2">AUD / month</div>
          </div>
        </div>
        <div>
          <h2 className="font-head font-extrabold text-3xl md:text-4xl uppercase tracking-tight mb-6">Everything Included</h2>
          <div className="border border-white/10">
            {PERKS.map((f) => (
              <div key={f} className="flex items-center gap-3 p-4 border-b border-white/10 last:border-b-0">
                <CheckCircle2 className="w-5 h-5 text-volt shrink-0" />
                <span className="text-sm tracking-wide">{f}</span>
              </div>
            ))}
          </div>
          <Link to="/register" data-testid="membership-page-join-btn" className="mt-8 inline-flex items-center gap-2 bg-volt text-white px-8 py-4 font-head font-bold uppercase tracking-wide hover:bg-blue-600 transition-colors">
            Join For ${price}/mo <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
      <SavingsCalculator price={price} />
      <SiteFooter />
    </div>
  );
}
